export const SET_SOCKET = 'SET_SOCKET';
